import type { Devo } from "~/hooks/usePlayerStore";
import { hasEligibleMeditationMoment } from "~/lib/meditationMoment";

export type PostMainPrompt = "outro-video" | "meditation" | "share";

type PostMainPromptDevo = Pick<Devo, "meditationMoment" | "outroVideoVimeoId" | "sharePercentage">;

export function getWinningPostMainPrompt(
  devo: PostMainPromptDevo,
  options?: { sharePopupEnabled?: boolean },
): PostMainPrompt | null {
  if (devo.outroVideoVimeoId) {
    return "outro-video";
  }

  if (hasEligibleMeditationMoment(devo)) {
    return "meditation";
  }

  if (options?.sharePopupEnabled !== false && devo.sharePercentage !== null) {
    return "share";
  }

  return null;
}
